const fieldsForCleaning = ["panelId", "projectId", "campaignId", "kitId"];

export default fieldsForCleaning;
